import { ModalWrapper } from "../../utils/fw"
import { WhatsOnBreakouts } from "../components/WhatsOn"
import { isMember } from "../utils"


const memberLinks = [
	{
		height: "36.3%",
		href: "/breakout-one",
		onClick: () => window.openChat("breakout-1"),
		label: "Breakout 1",
		left: "0%",
		top: "36%",
		width: "15.5%",
	},
	{
		height: "23.9%",
		href: "/breakout-two",
		onClick: () => window.openChat("breakout-2"),
		label: "Breakout 2",
		left: "22.8%",
		top: "33.8%",
		width: "10.7%",
	},
	{
		height: "31.6%",
		href: "/breakout-three",
		onClick: () => window.openChat("breakout-3"),
		label: "Breakout 3",
		left: "66.2%",
		top: "35.1%",
		width: "13.5%",
	},
	{
		height: "29.3%",
		href: "/engagement-sessions",
		label: "ISF Engagement Sessions",
		left: "15.9%",
		top: "59.5%",
		width: "8.8%",
	},
	{
		height: "23.9%",
		label: "What's On Now",
		left: "84.5%",
		top: "71.5%",
		width: "10.1%",
		modal: <ModalWrapper>
			<WhatsOnBreakouts />
		</ModalWrapper>
	},
]

export default {
	background: "https://assets.swoogo.com/uploads/full/5403551-6838c7d69578d.jpg",
	links: [
		{
			height: "35.3%",
			href: "/breakout-four",
			onClick: () => window.openChat("breakout-4"),
			label: "Breakout 4",
			left: "81.9%",
			top: "35.5%",
			width: "16.8%",
		},
		...(isMember ? memberLinks : []),
	],
	name: "breakouts",
}
